import { Box, Chip, Typography } from "@mui/material";
import { Column } from "../types/Column";

export default function ColumnHeader({
  column,
  contacts,
}: {
  column: Column;
  contacts: number;
}) {
  const backgroundColor = column.color[100];
  const borderTopColor = column.color[700];
  const iconColor = column.color[600];

  return (
    <Box
      sx={{
        p: 2,
        display: "flex",
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        justifyContent: "space-between",
        backgroundColor,
        alignItems: "center",
        borderTop: "8px solid",
        borderTopColor,
        "& > .MuiSvgIcon-root": {
          color: iconColor,
          fontSize: "32px",
        },
      }}
    >
      {column.icon}
      <Typography variant="h5" sx={{ ml: 1, fontWeight: "bold" }}>
        {column.name}
      </Typography>

      <Chip label={contacts} />
    </Box>
  );
}
